import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/work/new")({
  component: () => (
    <div className="min-h-dvh bg-surface">
      <Outlet />
    </div>
  ),
});
